import { useEffect, useState } from 'react';
import useUserApi, { ErrorHandler } from '../Services/UserApi';
import { EftposAccount } from 'shared-components';

export default function useEftposAccount() {
	const [eftposAccount, setEftposAccount] = useState<EftposAccount>();

	const userApi = useUserApi();

	useEffect(() => {
		userApi<{ eftposAccount: EftposAccount }>({
			route: `eftpos/api`,
			data: {
				action: 'getEftposAccount',
			},
			errorMessage: 'Error loading eftpos account',
		})
			.then((res) => {
				setEftposAccount(res.data.eftposAccount);
			})
			.catch((e: unknown) => ErrorHandler.toast(e));
	}, [userApi]);

	return { eftposAccount, setEftposAccount };
}
